import { Bank } from '@phosphor-icons/react';

export default Bank;
